// extracted by mini-css-extract-plugin
module.exports = {"Login":"Login_Login__2TfJr","Icon":"Login_Icon__VzilU","Button":"Login_Button__1EPLq","Description":"Login_Description__2yXny","Content":"Login_Content__Cd4s8"};